import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/base/Seo';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Seo
        title="页面未找到 - 菠萝蜜网"
        description="抱歉，您访问的页面不存在或已被移除，请返回菠萝蜜网首页继续浏览精彩影视内容。"
      />
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-16 md:py-24">
        <div className="text-center max-w-md">
          <div className="w-20 h-20 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-6">
            <i className="ri-film-fill text-3xl text-primary-500"></i>
          </div>
          <h1 className="text-6xl md:text-7xl font-black text-primary-200 select-none">404</h1>
          <h2 className="mt-4 text-xl md:text-2xl font-bold text-foreground-900">没有找到这个页面</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            抱歉，您要访问的内容可能已下架或链接有误。不妨回到首页，发现更多精彩影视资源。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-5-line"></i> 返回首页
            </Link>
            <Link
              to="/search"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-100 hover:bg-background-200 text-foreground-800 px-6 py-3 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line"></i> 搜索影视
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}